module.exports = __webpack_public_path__ + "img/background065.jpg";